(function () {
  "use strict";

  var e = {
    n: function n(_n) {
      var t = _n && _n.__esModule ? function () {
        return _n.default;
      } : function () {
        return _n;
      };
      return e.d(t, {
        a: t
      }), t;
    },
    d: function d(n, t) {
      for (var r in t) {
        e.o(t, r) && !e.o(n, r) && Object.defineProperty(n, r, {
          enumerable: !0,
          get: t[r]
        });
      }
    },
    o: function o(e, n) {
      return Object.prototype.hasOwnProperty.call(e, n);
    },
    r: function r(e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }
  },
      n = {};
  e.r(n), e.d(n, {
    FlagContext: function FlagContext() {
      return o;
    },
    FlagProvider: function FlagProvider() {
      return a;
    },
    InMemoryStorageProvider: function InMemoryStorageProvider() {
      return t.InMemoryStorageProvider;
    },
    LocalStorageProvider: function LocalStorageProvider() {
      return t.LocalStorageProvider;
    },
    UnleashClient: function UnleashClient() {
      return t.UnleashClient;
    },
    default: function _default() {
      return v;
    },
    useFlag: function useFlag() {
      return i;
    },
    useFlags: function useFlags() {
      return l;
    },
    useFlagsStatus: function useFlagsStatus() {
      return c;
    },
    useUnleashClient: function useUnleashClient() {
      return d;
    },
    useUnleashContext: function useUnleashContext() {
      return s;
    },
    useVariant: function useVariant() {
      return f;
    }
  });

  var t = require("unleash-proxy-client"),
      r = require("react"),
      o = e.n(r)().createContext(null);

  var u = {
    bootstrap: [],
    disableRefresh: !0,
    disableMetrics: !0,
    url: "http://localhost",
    appName: "offline",
    clientKey: "not-used"
  };

  var a = function a(e) {
    var n = e.config,
        a = e.children,
        i = e.unleashClient,
        l = e.startClient,
        c = void 0 === l || l,
        f = n || u,
        s = r.useRef(i || new t.UnleashClient(f)),
        d = r.useState(Boolean(i ? (null == n ? void 0 : n.bootstrap) && !1 !== (null == n ? void 0 : n.bootstrapOverride) : f.bootstrap && !1 !== f.bootstrapOverride)),
        v = d[0],
        p = d[1],
        b = r.useState(null),
        g = b[0],
        y = b[1],
        h = r.useRef(null);
    r.useEffect(function () {
      f || i || console.error("You must provide either a config or an unleash client to the flag provider.\n        If you are initializing the client in useEffect, you can avoid this warning\n        by checking if the client exists before rendering.");

      var e,
          n = function n(e) {
        h.current = e, null === h.current && y(e);
      },
          t = function t() {
        e = setTimeout(function () {
          p(!0);
        }, 0);
      };

      return s.current.on("ready", t), s.current.on("error", n), (c || !i) && (s.current.stop(), s.current.start()), function () {
        s.current && (s.current.off("error", n), s.current.off("ready", t), s.current.stop()), e && clearTimeout(e);
      };
    }, []);

    var m = function m(e) {
      return n = void 0, t = void 0, o = function o() {
        return function (e, n) {
          var t,
              r,
              o,
              u,
              a = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
          return u = {
            next: i(0),
            throw: i(1),
            return: i(2)
          }, "function" == typeof Symbol && (u[Symbol.iterator] = function () {
            return this;
          }), u;

          function i(u) {
            return function (i) {
              return function (u) {
                if (t) throw new TypeError("Generator is already executing.");

                for (; a;) {
                  try {
                    if (t = 1, r && (o = 2 & u[0] ? r.return : u[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, u[1])).done) return o;

                    switch (r = 0, o && (u = [2 & u[0], o.value]), u[0]) {
                      case 0:
                      case 1:
                        o = u;
                        break;

                      case 4:
                        return a.label++, {
                          value: u[1],
                          done: !1
                        };

                      case 5:
                        a.label++, r = u[1], u = [0];
                        continue;

                      case 7:
                        u = a.ops.pop(), a.trys.pop();
                        continue;

                      default:
                        if (!((o = (o = a.trys).length > 0 && o[o.length - 1]) || 6 !== u[0] && 2 !== u[0])) {
                          a = 0;
                          continue;
                        }

                        if (3 === u[0] && (!o || u[1] > o[0] && u[1] < o[3])) {
                          a.label = u[1];
                          break;
                        }

                        if (6 === u[0] && a.label < o[1]) {
                          a.label = o[1], o = u;
                          break;
                        }

                        if (o && a.label < o[2]) {
                          a.label = o[2], a.ops.push(u);
                          break;
                        }

                        o[2] && a.ops.pop(), a.trys.pop();
                        continue;
                    }

                    u = n.call(e, a);
                  } catch (e) {
                    u = [6, e], r = 0;
                  } finally {
                    t = o = 0;
                  }
                }

                if (5 & u[0]) throw u[1];
                return {
                  value: u[0] ? u[1] : void 0,
                  done: !0
                };
              }([u, i]);
            };
          }
        }(this, function (n) {
          switch (n.label) {
            case 0:
              return [4, s.current.updateContext(e)];

            case 1:
              return n.sent(), [2];
          }
        });
      }, new ((r = void 0) || (r = Promise))(function (e, u) {
        function a(e) {
          try {
            l(o.next(e));
          } catch (e) {
            u(e);
          }
        }

        function i(e) {
          try {
            l(o.throw(e));
          } catch (e) {
            u(e);
          }
        }

        function l(n) {
          var t;
          n.done ? e(n.value) : (t = n.value, t instanceof r ? t : new r(function (e) {
            e(t);
          })).then(a, i);
        }

        l((o = o.apply(n, t || [])).next());
      });
      var n, t, r, o;
    },
        x = function x(e) {
      return s.current.isEnabled(e);
    },
        C = function C(e) {
      return s.current.getVariant(e);
    },
        S = function S(e, n, t) {
      return s.current.on(e, n, t);
    },
        w = r.useMemo(function () {
      return {
        on: S,
        updateContext: m,
        isEnabled: x,
        getVariant: C,
        client: s.current,
        flagsReady: v,
        flagsError: g,
        setFlagsReady: p,
        setFlagsError: y
      };
    }, [v, g]);

    return r.createElement(o.Provider, {
      value: w
    }, a);
  },
      i = function i(e) {
    var n = (0, r.useContext)(o),
        t = n.isEnabled,
        u = n.client,
        a = (0, r.useState)(!!t(e)),
        i = a[0],
        l = a[1],
        c = (0, r.useRef)();
    return c.current = i, (0, r.useEffect)(function () {
      if (u) {
        var n = function n() {
          var n = t(e);
          n !== c.current && (c.current = n, l(!!n));
        },
            r = function r() {
          var n = t(e);
          c.current = n, l(n);
        };

        return u.on("update", n), u.on("ready", r), function () {
          u.off("update", n), u.off("ready", r);
        };
      }
    }, [u]), i;
  },
      l = function l() {
    var e = (0, r.useContext)(o).client,
        n = (0, r.useState)(e.getAllToggles()),
        t = n[0],
        u = n[1];
    return (0, r.useEffect)(function () {
      var n = function n() {
        u(e.getAllToggles());
      };

      return e.on("update", n), function () {
        e.off("update", n);
      };
    }, []), t;
  },
      c = function c() {
    var e = (0, r.useContext)(o);
    return {
      flagsReady: e.flagsReady,
      flagsError: e.flagsError
    };
  },
      f = function f(e) {
    var n = (0, r.useContext)(o),
        t = n.getVariant,
        u = n.client,
        a = (0, r.useState)(t(e)),
        i = a[0],
        l = a[1],
        c = (0, r.useRef)({
      name: i.name,
      enabled: i.enabled
    });
    return c.current = i, (0, r.useEffect)(function () {
      if (u) {
        var n = function n() {
          var n = t(e);
          c.current.name === (null == n ? void 0 : n.name) && c.current.enabled === (null == n ? void 0 : n.enabled) || (l(n), c.current = n);
        },
            r = function r() {
          var n = t(e);
          c.current.name = null == n ? void 0 : n.name, c.current.enabled = null == n ? void 0 : n.enabled, l(n);
        };

        return u.on("update", n), u.on("ready", r), function () {
          u.off("update", n), u.off("ready", r);
        };
      }
    }, [u]), i || {};
  },
      s = function s() {
    return (0, r.useContext)(o).updateContext;
  },
      d = function d() {
    return (0, r.useContext)(o).client;
  },
      v = a;

  module.exports = n;
})();